export default "__VITE_ASSET__CmW49$AS__"